import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';

@Injectable({
  providedIn: 'root',
})
export class EmailVerificationGuard implements CanActivate {
  constructor(private authStore: AuthStoreService, private router: Router) {}

  public canActivate(): boolean | UrlTree {
    if (!this.authStore.userInfo || this.authStore.userInfo.email_verified) {
      return this.router.parseUrl('/auth/login');
    }

    return true;
  }
}
